export default "__VITE_ASSET__bI_NrLch__"